import { render, staticRenderFns } from "./Emergenza.vue?vue&type=template&id=257339e2&"
import script from "./Emergenza.vue?vue&type=script&lang=js&"
export * from "./Emergenza.vue?vue&type=script&lang=js&"
import style0 from "./Emergenza.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports